import { BaseExtension } from '../registry/extension';
export class BaseTransform extends BaseExtension {
    beforeDraw(data, context) {
        return data;
    }
}
//# sourceMappingURL=base-transform.js.map